module.exports = __webpack_public_path__ + "img/against-the-real.9d3c0a47.jpg";